import { MenuItem, Select, Typography, Box } from '@mui/material'
import { IDropdown } from './types'
import { ReactComponent as ArrowIcon } from '../../assets/images/arrowIcon.svg'
import colors from '../../constants/colors'
import { Controller } from 'react-hook-form'
import LabelErrorTAG from '../LabelErrorTAG'
import { FC } from 'react'

const selectStyle = {
  '&.MuiSelect-outlined , .MuiOutlinedInput-input': {
    p: '.8rem',
    marginTop: 0,
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: colors.WHITE,
  },
  '&.MuiSelect-root , .MuiSelect-icon': {
    top: 'auto !important',
    right: '1.2rem',
    fill: colors.TAG_LINES_GRAY,
  },
  width: '100%',
}

const Dropdown: FC<IDropdown> = ({
  label = '',
  selectedValue,
  options,
  placeholder = 'Select a Option',
  control,
  fieldName,
  error = '',
  sx = {},
  typographyVariant = 'bodyBold',
  className = '',
  previewOnly = false,
}) => {
  const renderSelectOptions = () => {
    return options.map((selectOption, index) => {
      const customProps =
        selectOption.label === 'Immediate Attention Required' ? { color: colors.TAG_RED } : {}
      return (
        <MenuItem value={selectOption.value} key={`${selectOption.label}-${index}`}>
          <Typography variant={typographyVariant} {...customProps}>
            {selectOption.label}
          </Typography>
        </MenuItem>
      )
    })
  }

  return (
    <Box className={`t-dropdown t-vbox ${className}`}>
      {label && <LabelErrorTAG label={label} error={error} />}
      {control && (
        <Controller
          render={({ field }) => (
            <Select
              {...field}
              IconComponent={ArrowIcon}
              sx={{ ...selectStyle, ...sx }}
              displayEmpty
              renderValue={
                selectedValue && selectedValue !== ''
                  ? undefined
                  : () => (
                      <Typography variant='bodyRegular' color={colors.TAG_TEXT_GRAY}>
                        {placeholder}
                      </Typography>
                    )
              }
              disabled={previewOnly}
            >
              {renderSelectOptions()}
            </Select>
          )}
          name={fieldName}
          control={control}
          defaultValue={''}
        />
      )}
    </Box>
  )
}

export default Dropdown
